import styled from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'

const CTAButton = styled(Button)`
  width: 100%;
  margin-bottom: 15px;
`

export { CTAButton }
